export default __webpack_public_path__ + "static/media/new_core_value.60d39037.jpg";